<template>
  <!-- OTC -->
  <div id="OTC">
    <!-- 内容区域 -->

    <el-container style="width: 100%;height: 100%; background: #949494;">
      <!-- <el-header>Header</el-header> -->
      <!-- <el-main> -->

        <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
          <!-- <HomeList style="height: 100%; width: 100%;"></HomeList> -->
          <div class="CodeForm">

            <p style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 1.5625rem;">BTC Address</p>

            <div id="qqq">
              <div id="qrCode" ref="qrCodeDiv"></div>
            </div>
            <p id="codeText" style="width: 100%;text-align: center;">xxxxxxxxxxxxxxx</p>

            <mu-button @click="submit($event)" class="copyBtn">Copy the above address</mu-button>
          </div>
        </mu-flex>

      <!-- </el-main> -->
      <el-footer>
          <BottomNav style="height: 100%; width: 100%;"></BottomNav>
          </el-footer>
    </el-container>


  </div>
</template>

<script>
  import $ from 'jquery'
  import BottomNav from '../Bottom-nav.vue'
  import QRCode from 'qrcodejs2';
  import Clipboard from 'clipboard'
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  export default {
    // name: "qrCode",
    data() {
      return {
        // //表格
        // tableData: [{Thao:"ces",mmsi:"123"},{Thao:"ces",mmsi:"123"},{Thao:"ces",mmsi:"123"}],
        // pageIndex: 1,
        // //下拉刷新，上拉加载
        // refreshing: false,
        // loadings: false,
        // loadedall: false
        QRCodeText:""
      }
    },
    mounted() {

      this.$nextTick(function() {
        var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
        // console.log(UserInfo.bTC_address);
        // this.QRCodeText = "13KfhCLnNoBo6EbCSMpp6ihriQGz2Jbynx";
        this.bindQRCode(UserInfo.bTC_address);
        $("#codeText").html(UserInfo.bTC_address);
      })
    },
    methods: {
      bindQRCode: function(qcode) {
        new QRCode(this.$refs.qrCodeDiv, {
          text: qcode,
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        })
      },
      submit (e) {
        console.log("---------");
        // console.log(this.QRCodeText);
        // console.log($("#codeText").append(item));
        // console.log($("#codeText"));
//从属性里复制
    // var btn = document.getElementById('codeText');
    // var clipboard = new Clipboard($("#codeText").text());//实例化
    var clipboard = new Clipboard(e.target, {
            text: () => $("#codeText").text()
          });
    clipboard.on('success', () => {
        this.$message({
          message: 'Copy success',
          type: 'success'
        });
            // clipboardError();
            // 释放内存
            clipboard.destroy()
        });
        clipboard.on('error', () => {
        this.$message.error('Copy error');
            // 不支持复制
            // clipboardError();
            // 释放内存
            clipboard.destroy()
        });
        // 解决第一次点击不生效的问题，如果没有，第一次点击会不生效
        clipboard.onClick(e);
      }
    },
    components: {
      BottomNav
    }
  };
</script>

<style>
  #OTC .mu-appbar .mu-appbar-title {
    text-align: center;
  }

  #OTC .is-full-width {
    width: 100%;
  }

  #OTC .content {
    flex: 1
  }

  #OTC .container {
    width: 100%;
    height: 70%;
    padding-right: 0px;
    padding-left: 0px;
    /* margin-right: auto; */
    /* margin-left: auto; */
  }
  #OTC .CodeForm {
      width: 100%;
      height: 25rem;
      /* padding-right: 20px;
      padding-left: 20px; */
      margin-left: 20px;
      margin-right: 20px;
      background-color: #ffffff;
      align-self: center;
      border-radius: 5px;
/*      display: flex;
      align-items: center; */
  }

  #OTC .copyBtn {
    margin: 0 auto; /*水平居中*/
    display: flex;
    /* padding: 30px; */
    font-size: 15px;
    color: #FFFFFF;
    background-color: #303644;
    border-radius: 30px;
  }

  #qqq {
    /* background-color: #111; */
/*   width:300px;
    height:300px; */
    margin: 0 auto; /*水平居中*/
    margin-top: 1.875rem;
    position: relative;
    display: flex;
  }

  #qrCode {
    display: inline-block;
    margin: 0 auto; /*水平居中*/
    position: relative;
    /* top: 15%; */

    img {
      width: 200px;
      height: 200px;
      /* background-color: #fff; //设置白色背景色 */
      /* padding: 6px; // 利用padding的特性，挤出白边 */
    }
    }
  @import '../../../Comm/css/CommCSS.css';
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/OTC/OTC.vue